import { createTopic } from "../../utils/topic-utils";
import decorators from "./decorators";

const user = {
  state: {},
  properties: [
    {
      id: "language",
      type: "Select",
      defaultValue: "global",
      options: [
        { value: "global", label: "EN" },
        { value: "fi-FI", label: "FI" },
        { value: "fr-FR", label: "FR" },
        { value: "de-DE", label: "DE" },
        { value: "pl-PL", label: "PL" },
        { value: "it-IT", label: "IT" },
        { value: "es-ES", label: "ES" },
        { value: "da-DK", label: "DK" },
        { value: "se-SE", label: "SE" },
        { value: "no-NO", label: "NO" },
        { value: "pt-PT", label: "PT" },
        { value: "ru-RU", label: "RU" },
        { value: "nl-NL", label: "NL" },
      ],
    },
  ],
};

const tractor = {
  state: {},
  properties: [
    /* {
      id: "playing",
      type: "Boolean",
      defaultValue: false,
    }, */
    {
      id: "type",
      type: "Select",
      defaultValue: "direct",
      valueType: "String",
      options: [
        {
          value: "direct",
          label: "type-direct",
          description: {
            title: "type-direct-title",
            subtitle: "type-direct-subtitle",
            body: "type-direct-body",
          },
        },
        {
          value: "versu",
          label: "type-versu",
          description: {
            title: "type-versu-title",
            subtitle: "type-versu-subtitle",
            body: "type-versu-body",
          },
        },
        {
          value: "active",
          label: "type-active",
          description: {
            title: "type-active-title",
            subtitle: "type-active-subtitle",
            body: "type-active-body",
          },
        },
        {
          value: "hitech",
          label: "type-hitech",
          description: {
            title: "type-hitech-title",
            subtitle: "type-hitech-subtitle",
            body: "type-hitech-body",
          },
        },
      ],      
      // Basic control option is visible only for Active & Hitech types
      decorator: decorators.decorateType
    },
    {
      id: "color",
      type: "Select",
      valueType: "Color",
      defaultValue: "white-metallic",
      options: [
        "black-metallic",
        "blue-metallic",
        "bronze-metallic",
        "olive-green-metallic",
        "red",
        "red-metallic",
        "white-metallic",
      ],
    },
    {
      id: "wheelColor",
      type: "Select",
      valueType: "Color",
      defaultValue: "white-wheel",
      label: "wheel-color-label",
      options: [
        { value: "white-wheel", label: "white" },
        { value: "black-wheel", label: "black" },
      ],
    },
    {
      id: "view",
      type: "Select",
      defaultValue: "exterior",
      options: [
        {
          value: "exterior",
          label: "view-exterior",
          parent: null,
          camera: { position: [5, 1.5, -2], target: [1.4, 0.5, 0] },
        },
        {
          value: "interior",
          label: "view-interior",
          parent: "exterior",
          camera: { position: [0.4, 1.6, 0], target: [0.5, 1.58, 0] },
        },
      ],
    },
    {
      id: "loader",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "loaderPosition",
      label: "loader-position-label",
      type: "Number",
      defaultValue: 0,
      min: 0,
      max: 0.7,
      step: 0.01,
    },
    {
      id: "premiumInterior",
      label: "premium-Interior-label",
      type: "Boolean",
      defaultValue: false,
      decorator: {
        skyview: false,
      },
    },
    {
      id: "technologyPackage",
      label: "technology-package-label",
      type: "Boolean",
      defaultValue: false,
      decorator: {
        skyview: false,
      },
    },
    {
      id: "twintrack",
      type: "Boolean",
      defaultValue: false,
      decorator: {
        coolbox: false,
      },
    },
    {
      id: "coolbox",
      type: "Boolean",
      defaultValue: false,
      decorator: {
        twintrack: false,
      },
    },
    {
      id: "skyview",
      type: "Boolean",
      defaultValue: false,
      decorator: {
        premiumInterior: false,
        technologyPackage: false,
      },
    },
    {
      id: "forestTank",
      label: "forest-tank-label",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "frontLinkage",
      label: "front-linkage-label",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "twoDoor",
      label: "two-door-label",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "evolutionSeat",
      label: "evolution-seat-label",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "basicControl",
      label: "basic-control-label",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "environment",
      type: "Select",
      valueType: "String",
      defaultValue: "field",
      options: [
        {
          value: "field",
          label: "environment-field",
        },
        {
          value: "showroom",
          label: "environment-showroom",
        },
      ],
    },
     {
      id: "steeringAngle",
      label: "steering-angle-label",
      type: "Number",
      defaultValue: 0.6666666865348816 / 2,
      min: 0,
      max: 0.6666666865348816,
      step: 0.001,
    }, 
    {
      id: "doorOpen_R",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "doorOpen_L",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "toolboxOpen",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "seatDown",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "backrest",
      type: "Boolean",
      defaultValue: false,
    },
    /////
    {
      id: "seatArmRestRightTilt",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "seatArmRestLeftTilt",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "seatHeadRestTilt",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "seatRotate",
      type: "Boolean",
      defaultValue: false,
      decorator: decorators.decorateSeatRotate   
    },
    {
      id: "twinTrackTilt",
      type: "Boolean",
      defaultValue: false,
    },


    //////
    {
      id: "coolboxOpen",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "sunscreenDown",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "hitchUp",
      type: "Boolean",
      defaultValue: true,
    },
    {
      id: "frontLinkageUp",
      type: "Boolean",
      defaultValue: true,
    },
    {
      id: "frontLinkageWorkDrive",
      type: "Boolean",
      defaultValue: true,
    },
    {
      id: "hatchOpen",
      type: "Boolean",
      decorator: decorators.hatchOpen,
      defaultValue: false,
    },
    {
      id: "steeringwheel_tilt",
      type: "Boolean",
      decorator: decorators.steeringwheel_tilt,
      defaultValue: false,
    },
    {
      id: "topic",
      type: "Select",
      defaultValue: null,
      options: [
        // exterior
        {
          value: "type",
          label: "type",
          icon: "icon-type",
          view: "exterior",
          properties: ["type"],
        },
        {
          value: "basicControl",
          label: "basic-control",
          icon: "icon-basic-control",
          view: "exterior",
          properties: ["basicControl"],
          description: {
            title: "basic-control-title",
            subtitle: "basic-control-subtitle",
            body: "basic-control-body",
          },
          disabled: true
        },
        {
          value: "color",
          label: "color",
          icon: "icon-colour",
          view: "exterior",
          properties: ["color"],
        },
        {
          value: "wheelColor",
          label: "wheel-color",
          icon: "icon-colour",
          view: "exterior",
          properties: ["wheelColor"],
        },
        {
          value: "frontLinkage",
          label: "front-linkage",
          icon: "icon-front-linkage",
          view: "exterior",
          properties: ["frontLinkage"],
          description: {
            title: "front-linkage-title",
            subtitle: "front-linkage-subtitle",
            body: "front-linkage-body",
          },
        },
        {
          value: "loader",
          label: "loader",
          icon: "icon-loader",
          view: "exterior",
          properties: ["loader", "loaderPosition"],
          description: {
            title: "loader-title",
            subtitle: "loader-subtitle",
            body: "loader-body",
          }
        },
        {
          value: "forestTank",
          label: "forest-tank",
          icon: "icon-forest-tank",
          view: "exterior",
          properties: ["forestTank"],
          description: {
            title: "forest-tank-title",
            subtitle: "forest-tank-subtitle",
            body: "forest-tank-body",
          },
        },
        {
          value: "skyview",
          label: "skyview",
          icon: "icon-skyview",
          view: "exterior",
          properties: ["skyview"],
          description: {
            title: "skyview-title",
            body: "skyview-body",
          },
        },
        {
          value: "coolbox",
          label: "coolbox",
          icon: "icon-coolbox",
          view: "exterior",
          properties: ["coolbox"],
          description: {
            title: "coolbox-title",
            subtitle: "coolbox-subtitle",
            body: "coolbox-body",
          },
        },
        {
          value: "twintrack",
          label: "twintrack",
          icon: "icon-twintrack",
          view: "exterior",
          properties: ["twintrack"],
          description: {
            title: "twintrack-title",
            subtitle: "twintrack-subtitle",
            body: "twintrack-body",
          },
        },
        {
          value: "evolutionSeat",
          label: "evolution-seat",
          icon: "icon-evolution-seat",
          view: "exterior",
          properties: ["evolutionSeat"],
          description: {
            title: "evolution-seat-title",
            subtitle: "evolution-seat-subtitle",
            body: "evolution-seat-body",
          },
        },
        {
          value: "premiumInterior",
          label: "premium-Interior",
          icon: "icon-premium-interior",
          view: "interior",
          properties: ["premiumInterior"],
          description: {
            title: "premium-Interior-title",
            subtitle: "premium-Interior-subtitle",
            body: "premium-Interior-body",
          },
        },
        {
          value: "twoDoor",
          label: "two-door",
          icon: "icon-two-door",
          view: "exterior",
          properties: ["twoDoor"],
          description: {
            title: "two-door-title",
            subtitle: "two-door-subtitle",
            body: "two-door-body",
          },
        },
        {
          value: "technologyPackage",
          label: "technology-package",
          icon: "icon-technology-package",
          view: "interior",
          properties: ["technologyPackage"],
          description: {
            title: "technology-package-title",
            subtitle: "technology-package-subtitle",
            body: "technology-package-body",
          },
        },
        {
          value: "steeringAngle",
          label: "steering-angle",
          icon: "icon-steering-angle",
          properties: ["steeringAngle"],
          description: {
            title: "steering-angle-title",
            subtitle: "steering-angle-subtitle",
            body: "steering-angle-body",
          },
        },
        {
          value: "environment",
          label: "environment",
          icon: "icon-environment",
          properties: ["environment"],
          description: {
            title: "environment-title",
            subtitle: "environment-subtitle",
            body: "environment-body",
          },
        },
        
        createTopic("content-1"),
        createTopic("content-2"),
        createTopic("content-3"),
        createTopic("content-4"),
        createTopic("content-5"),
        createTopic("content-6"),
        createTopic("content-7"),
        createTopic("content-8"),
        createTopic("content-9"),
        createTopic("content-10"),
        createTopic("content-11"),
      ],
    },
  ],
};

export default { user, tractor };
